import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import './index.css';
import { initDebugConsole } from './lib/debugConsole';

// Mobile DevTools overlay — aktywne tylko gdy ?debug=1 lub localStorage flag.
// Bezbolesne dla normalnych userów: eruda nie ładuje się, chyba że włączone.
initDebugConsole();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
